import axios from "axios";

// Create a centralized Axios instance configured with your backend URL
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  headers: {
    "Content-Type": "application/json",
  },
});

// Auto-inject the Authorization token if the user is logged in
API.interceptors.request.use(
  (config) => {
    try {
      const authData = localStorage.getItem("auth");
      if (authData) {
        const parsed = JSON.parse(authData);
        if (parsed && parsed.token) {
          config.headers.Authorization = `Bearer ${parsed.token}`;
        }
      }
    } catch (error) {
      console.error("Failed to parse auth token in Axios interceptor:", error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
  
);
/* =========================================================
   RESPONSE INTERCEPTOR
========================================================= */

API.interceptors.response.use(

  (response) => response,

  (error) => {

    /* NO PERMISSION */
    if (error.response?.status === 403) {

      window.location.href =
        "/no-permission";

    }

    return Promise.reject(error);

  }
);
export default API;
